import Head from 'next/head'
import Link from 'next/link'

import { Logo } from '@/components/ui/Logo'
import { SlimLayout } from '@/components/layout/SlimLayout'
import { AuthHeader } from '@/components/features/auth/AuthUi'

export default function VerifyRequest() {
  return (
    <SlimLayout>
      <Head>
        <title>Check Your Email - ReceiptsAI</title>
      </Head>
      <div className="flex">
          <Logo className="h-10 w-auto" />
      </div>
      <AuthHeader
        title="Check your email"
        subtitle="We just sent you a magic sign-in link. Click it and you're in — check spam if it doesn't arrive within a minute."
      />
      <p className="mt-8 text-sm text-gray-500">
        Wrong address?{' '}
        <Link
          href="/auth/login"
          className="font-medium text-blue-600 hover:text-blue-500"
        >
          Use a different email
        </Link>
      </p>
    </SlimLayout>
  )
}
